Foundation.Mobile.Search = function (comp_el) {
    if (this.instance) {
        return this.instance;
    }

    this.component = jQuery(comp_el);
    this.link_dropdown = comp_el.find('.search-link-dropdown');
    this.height = this.component.find('.wrapper').outerHeight();

    this.input = comp_el.find('.search-input');
    this.links = comp_el.find('.search-link');
    this.form = comp_el.find('form#site-search');


    // show list if input is given foucs
    this.input.on('click focus', function () {
        this.link_dropdown.removeClass('hidden');
        this.height = this.component.find('.wrapper').outerHeight();
        this.component.css('height', `${this.height}px`);
    }.bind(this));

    // do navigation with search term
    this.links.on('click', function (e) {
        e.preventDefault();
        var href = jQuery(e.currentTarget).attr('href');
        var keywords = this.input.val();
        var target = new Foundation.URL(href, {keywords: keywords});
        window.location.href = target;
    }.bind(this));

    this.instance = this;
    window["Foundation"]["Mobile"]["Search"]["instance"] = this.instance;
}

Foundation.Mobile.Search.prototype.toggle = function () {
    this.height = this.component.find('.wrapper').outerHeight();

    if (this.component.hasClass('open')) {
        this.component.css('height', '0px');
        this.component.one("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function () {
          this.component.removeClass('open');
        }.bind(this));
        // fallback in case event not triggered
        window.setTimeout(function () {
          this.component.removeClass('open');
        }.bind(this), 350);
    }
    else {
        this.component.addClass('open');
        this.component.css('height', `${this.height}px`);
        this.component.find('#search').focus();
    }
}

Foundation.Mobile.Search.prototype.registerToggle = function (el) {
    jQuery(el).on('click', this.toggle.bind(this));
}

Foundation.Mobile.Search.getInstance


window["Foundation"]["Mobile"]["Search"] = Foundation.Mobile.Search;
window["Foundation"]["Mobile"]["Search"].prototype["registerToggle"] = Foundation.Mobile.Search.prototype.registerToggle;
window["Foundation"]["Mobile"]["Search"].prototype["toggle"] = Foundation.Mobile.Search.prototype.toggle;
window["Foundation"]["Mobile"]["Search"]["getInstance"] = function () {};
